import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import LoginView from '@/views/Login.view.vue';
import HomeView from '@/views/Home.view.vue';
import {RoutingPermissions} from '@/misc/RoutingPermissions';
import CustomersView from "@/views/Customers.view.vue";

import MapView from "@/views/Map.view.vue";
import MaintenanceToolView from "@/views/MaintenanceTool.view.vue";
import ActuatorOverviewView from "@/views/Actuators.view.vue";
import CustomerDetailsView from "@/views/CustomerDetails.view.vue";
import StationDetailsView from "@/views/StationDetails.view.vue";
import MachineDetailsView from "@/views/MachineDetails.view.vue";
import store from '@/store';

// Reports sub-views (lazy loaded)
const ReportsOverviewView  = () => import('@/views/reports/ReportsOverview.view.vue');
const ReportsLabelsView    = () => import('@/views/reports/ReportsLabels.view.vue');
const ReportsProjectsView  = () => import('@/views/reports/ReportsProjects.view.vue');
const ReportsCustomersView = () => import('@/views/reports/ReportsCustomers.view.vue');
const ReportsTechnicalView = () => import('@/views/reports/ReportsTechnical.view.vue');

const originalPush = VueRouter.prototype.push;
// @ts-ignore
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
// @ts-ignore
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/login',
        name: 'login_view',
        component: LoginView
    },
    {
        path: '/home',
        name: 'home_view',
        component: HomeView,
        beforeEnter: (to, from, next) => RoutingPermissions.checkAccess(to, from, next),
        children: [{
            path: '/customers',
            name: 'customers_view',
            component: CustomersView
        },
            {
                path: '/customers/:customerId',
                name: 'customer_details_view',
                component: CustomerDetailsView
            },
            {
                path: '/customers/:customerId/stations/:stationId',
                name: 'station_details_view',
                component: StationDetailsView,
            },
            {
                path: '/customers/:customerId/stations/:stationId/machines/:machineId',
                name: 'machine_details_view',
                component: MachineDetailsView,
            },
            {
                path: '/map',
                name: 'map_view',
                component: MapView
            },
            {
                path: '/maintenanceTool',
                name: 'maintenance_tool_view',
                component: MaintenanceToolView
            },
            {
                path: '/actuatorOverview',
                name: 'actuator_overview_view',
                component: ActuatorOverviewView
            },

            // Reports section
            {
                path: '/reports/overview',
                name: 'reports_overview_view',
                component: ReportsOverviewView
            },
            {
                path: '/reports/labels',
                name: 'reports_labels_view',
                component: ReportsLabelsView
            },
            {
                path: '/reports/projects',
                name: 'reports_projects_view',
                component: ReportsProjectsView
            },
            {
                path: '/reports/customers',
                name: 'reports_customers_view',
                component: ReportsCustomersView
            },
            {
                path: '/reports/technical',
                name: 'reports_technical_view',
                component: ReportsTechnicalView
            },

            {
                path: '', // Default route
                redirect: {name: 'customers_view'}
            },
            {
                path: '*',
                redirect: {name: 'customers_view'}
            }]
    },
    {
        path: '*',
        redirect: {name: 'login_view'}
    }
];

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    store.commit('settings/clearBreadcrumbContext');
    next();
});

export default router;
